<ng-container *transloco="let t">
  <div class="d-flex flex-column">
    <div class="race-grid-item" [class.is-last]="isLast">
      <!--      <app-races-header [race]="race"></app-races-header>-->
      <div class="race-grid-item--body">
        <div class="item-info d-flex align-items-start flex-column">
          <div class="w-100-sm-auto-xxl">
            <p class="large trim-text-third-line">
              <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                                   [srLabel]="race?.nameSr" [siLabel]="race?.nameSlo" [bsLabel]="race?.nameBs"
                                   [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
            </p>

            <div class="pt-3 pb-3 d-flex">
              <div class="pe-2" *ngIf="race?.length">
                <p class="badge medium d-inline-flex">
                  {{race?.length | raceLengthFormat:translocoService.getActiveLang(): "km"}} </p>
              </div>
              <p *ngIf="race?.sport" class="badge medium d-inline-flex">
                {{t("app.common.sports." + race?.sport)}} </p>
            </div>

            <div class="mb-1 d-flex flex-row justify-content-between align-items-center“">
              <div class="d-inline-flex align-items-center">
                <img src="assets/icons/icons-alt/event_note.svg" alt="">
                <p class="ps-1">{{
                    race && race.raceStart ? (race!.raceStart |
                        localizedDate:'short')
                      : '-'
                  }}</p>
              </div>
            </div>


            <div class="race-details mb-2 mb-md-3">
              <div class="race-details__item">
                <p class="fw-semibold">{{t("race.details.registration.until")}}</p>
                <p> {{
                    race
                      ? (race.registrationEnd | localizedDate:'short')
                      : '-'
                  }} </p>
              </div>
              <div class="race-details__item">
                <p class="fw-semibold"> {{t("event.item.participants")}}</p>
                <p> {{
                    race | raceCompetitorCountFormat
                  }} </p>
              </div>
              <div class="race-details__item">
                <p class="fw-semibold"> {{t("race.grid.elevation")}}</p>
                <p>
                  {{race | raceAscentDescentFormat}} </p>
              </div>
            </div>
            <p class="fw-semibold">
              {{t("race.details.price.from")}}: <span class="fw-normal">{{
                race
                  ? (raceCommercialItems | raceCommercialItemsMinPriceFormat:currencyLabel)
                  : '-'
              }}</span>
            </p>
          </div>
          <div class="d-flex flex-nowrap justify-content-end w-100 pt-20">
            <div class="ps-2">
              <a href="javascript:void(0);" class="text-decoration-underline text-uppercase anchor-btn"
                 (click)="onMore()">
                {{t('race.details.more.details')}}
              </a>
            </div>
            @if (!hideRegistration) {
            <div class="ps-2">
              <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [text]="t('race.grid.register')"
                              [borderColor]="'var(--teal-500)'" (onClickCallback)="onRegister()"
                              [isDisabled]="!race?.open"></app-button-alt>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
